export default __webpack_public_path__ + "img/publication/publication6_480.jpg";